import PropTypes from 'prop-types';
import Icon from '../../Icon';

import * as S from './style';
import * as T from '../../Typography';

function StatsCard(props) {
  const { loading, title, color, txt, statNum, percentage } = props;

  const numLength = statNum ? statNum.toString().length : 0;

  return (
    <S.CardWrapper>
      {loading ? (
        <S.Loading
          indicator={
            <Icon icon="spinner" width={`48px`} height={`48px`} color={color} />
          }
        />
      ) : (
        <S.StatsNum color={color} numLength={numLength}>
          {statNum || Number(statNum) === 0 || '-'}
          {statNum && percentage && (
            <T.Body16B as="span" color={color}>
              %
            </T.Body16B>
          )}
        </S.StatsNum>
      )}
      <div>
        {title && <T.BodyB color={color}>{title}</T.BodyB>}
        <T.Body16>{txt}</T.Body16>
      </div>
    </S.CardWrapper>
  );
}

StatsCard.defaultProps = {
  color: 'teal',
};

StatsCard.propTypes = {
  loading: PropTypes.bool,
  title: PropTypes.string,
  color: PropTypes.string,
  txt: PropTypes.string,
  statNum: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  percentage: PropTypes.bool,
};

export default StatsCard;
